import React from 'react';
interface FormulaRowProps {
  label: string;
  subLabel?: string;
  children: React.ReactNode;
  className?: string;
  isTotal?: boolean;
}
export function FormulaRow({
  label,
  subLabel,
  children,
  className = '',
  isTotal = false
}: FormulaRowProps) {
  return <div className={`flex flex-col sm:flex-row sm:items-center gap-4 py-3 ${isTotal ? 'border-t-2 border-slate-800 pt-4 mt-2' : 'border-b border-slate-100 last:border-0'} ${className}`} data-id="element-361">
      <div className="w-full sm:w-1/3 flex flex-col" data-id="element-362">
        <span className={`text-sm ${isTotal ? 'font-bold text-slate-900' : 'font-medium text-slate-700'}`} data-id="element-363">
          {label}
        </span>
        {subLabel && <span className="text-xs text-slate-500 mt-0.5" data-id="element-364">{subLabel}</span>}
      </div>
      <div className="w-full sm:w-2/3 flex items-center gap-3 flex-wrap sm:flex-nowrap" data-id="element-365">
        {children}
      </div>
    </div>;
}
export function Operator({
  symbol
}: {
  symbol: string;
}) {
  return <div className="flex items-center justify-center w-6 h-6 rounded-full bg-slate-100 text-slate-500 font-mono text-sm shrink-0" data-id="element-366">
      {symbol}
    </div>;
}